import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker } from './shared';

/**
 * KBD
 *
 * A keyboard shortcut, drawn as the key it names: a small muted cap with a
 * border, in the mono face at the overline size. The search bar wrote one by
 * hand at `text-[10px]`; the scale's smallest role is the right size and
 * moves with the rest of the type if it is ever retuned.
 *
 * `select-none` because a hint is not text anyone means to copy.
 */
export const kbdRecipe = cva(
  [
    uiMarker,
    'inline-flex select-none items-center gap-1 whitespace-nowrap',
    'rounded border border-border bg-muted text-muted-foreground',
    'font-mono text-overline font-medium',
  ],
  {
    variants: {
      size: {
        sm: 'h-5 px-1.5',
        md: 'h-6 px-2',
      },
    },
    defaultVariants: { size: 'sm' },
  }
);

export type KbdRecipeProps = VariantProps<typeof kbdRecipe>;
